export default __webpack_public_path__ + "static/media/holidays-white.8e7bd944.svg";